import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'
import * as Yup from 'yup'
import { date } from 'yup/lib/locale'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import axios from 'axios'

function CertificateDecCommittee() {
    const { orgcode } = useParams()
    const [initialValues, setInitialValues] = useState({
        legalname: "",
        _id: "",
        orgCode: 0,
        nabcbcode: "",
        nabcbcodeName: "",
        dateofaudit: "",
        typeofaudit: "",
        refno: "",
        standard: "",
        mandaysPlanned: "",
        teamleader: "",
        technicalexpert: "",
        teamleaderName:"",
        technicalExpertName: "",
        auditors: "",
        auditorsName: "",

        cdcmember: "",
        allactfoundsat: "Yes",
        certificationcriteria: "Yes",
        adejustification: "Yes",
        docreview: "",
        sysreview1: "Yes",
        sysreviewremark1: "",
        sysreview12: "Yes",
        sysreviewremark2: "",
        sysreview3: "Yes",
        sysreviewremark3: "",
        sysreview4: "Yes",
        sysreviewremark4: "",
        sysreview5: "Yes",
        sysreviewremark5: "",
        sysreview6: "Yes",
        sysreviewremark6: "",
        sysreview7: "Yes",
        sysreviewremark7: "",
        sysreview8: "Yes",
        sysreviewremark8: "",
        reviewbydate: new Date(),
        techreview1: "Yes",
        techreviewremark1: "",
        techreview2: "Yes",
        techreviewremark2: "",
        techreview3: "Yes",
        techreviewremark3: "",
        techreview4: "Yes",
        techreviewremark4: "",
        techreview5: "Yes",
        techreviewremark5: "",
        techreview6: "Yes",
        techreviewremark6: "",
        techreview7: "Yes",
        techreviewremark7: "",
        reviewbydate1:new Date(),
        cdcreviewcomments: "",
        reviewsysduringcert: "",
        certificatedec: "Yes",
        signcdcmem: "",
        dateofcdcdecision: new Date(),
        flatno: "",
        certificateno: "",
        initialcertdate: new Date(),
        dateofissue: new Date(),
        expirydate: new Date(),
        accreditationref: "",
        actionifany: "",
        signature: "",
        officeusedate: new Date()

    })
    const auditfindings = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'NO' }
    ]
    const options1 = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'NO' },
        { key: 'FIR', value: 'FIR' }
    ]
    const yesNo = [

        { key: 'Select', value: '-' },
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' },

    ]


    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () =>
            Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {})
    )
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.refno = data.data.response.refno || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.reviewbydate = Date.parse(data.data.response.reviewbydate) || null;
                tempInitialValues.reviewbydate1 = Date.parse(data.data.response.reviewbydate1) || null;
                tempInitialValues.dateofcdcdecision = Date.parse(data.data.response.dateofcdcdecision) || null;
                tempInitialValues.initialcertdate = Date.parse(data.data.response.initialcertdate) || null;
                tempInitialValues.expirydate = Date.parse(data.data.response.expirydate) || null;
                tempInitialValues.officeusedate = Date.parse(data.data.response.officeusedate) || null;
                tempInitialValues.dateofissue = Date.parse(data.data.response.dateofissue) || null;
                tempInitialValues.mandaysPlanned = data.data.response.mandaysPlanned || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";
                tempInitialValues.auditors = data.data.response.auditors || "";
                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.allactfoundsat = data.data.response.allactfoundsat || "Yes";
                tempInitialValues.certificationcriteria = data.data.response.certificationcriteria || "Yes";
                tempInitialValues.adejustification = data.data.response.adejustification || "Yes";

                tempInitialValues.sysreview1 = data.data.response.sysreview1 || "Yes";
                tempInitialValues.sysreview12 = data.data.response.sysreview12 || "Yes";
                tempInitialValues.sysreview3 = data.data.response.sysreview3 || "Yes";
                tempInitialValues.sysreview4 = data.data.response.sysreview4 || "Yes";
                tempInitialValues.sysreview5 = data.data.response.sysreview5 || "Yes";
                tempInitialValues.sysreview6 = data.data.response.sysreview6 || "Yes";
                tempInitialValues.sysreview7 = data.data.response.sysreview7 || "Yes";
                tempInitialValues.sysreview8 = data.data.response.sysreview8 || "Yes";

                tempInitialValues.techreview1 = data.data.response.techreview1 || "Yes";
                tempInitialValues.techreview2 = data.data.response.techreview2 || "Yes";
                tempInitialValues.techreview3 = data.data.response.techreview3 || "Yes";
                tempInitialValues.techreview4 = data.data.response.techreview4 || "Yes";
                tempInitialValues.techreview5 = data.data.response.techreview5 || "Yes";
                tempInitialValues.techreview6 = data.data.response.techreview6 || "Yes";
                tempInitialValues.techreview7 = data.data.response.techreview7 || "Yes";
                tempInitialValues.certificatedec = data.data.response.certificatedec || "Yes";
              
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
               mutationcertidetails.mutate(values)
                mutation.mutate(values)
    }
    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/cdc', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'CDC Data Added')
                window.location.href = "/"+localStorage.getItem("role")+"/view/certificatedeccommittee/" + data.data.response.orgCode
            } else {
                var msg = 'Audit Report - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationcertidetails = useMutation((params) => Fetcher('post', '/api/certificatedetails/post/databysystem', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                // ToastInstance('Success', 'CDC Data Added')
                // window.location.href = "/"+localStorage.getItem("role")+"/view/certificatedeccommittee/" + data.data.response.orgCode
            } else {
                var msg = 'cdc certification details - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stage2data=>{
            if (stage2data && initialValues.orgCode === 0) {
                var tempData = stage2data.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit) || null;
                tempData.reviewbydate = Date.parse(tempData.reviewbydate) || null;
                tempData.reviewbydate1 = Date.parse(tempData.reviewbydate1) || null;
                tempData.dateofcdcdecision = Date.parse(tempData.dateofcdcdecision) || null;
                tempData.initialcertdate = Date.parse(tempData.initialcertdate) || null;
                tempData.expirydate = Date.parse(tempData.expirydate) || null;
                tempData.officeusedate = Date.parse(tempData.officeusedate) || null;
                tempData.dateofissue = Date.parse(tempData.dateofissue) || null;
                setInitialValues(tempData)
            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const validationSchema = Yup.object({
                legalname               : Yup.string().required('Required'),
                standard                : Yup.string().required('Required'),
                cdcmember               : Yup.string().required('Required'),
                reviewbydate            : Yup.string().required('Required'),
                reviewbydate1           : Yup.string().required('Required'),
                flatno                  : Yup.string().required('Required'),
                certificateno           : Yup.string().required('Required'),
                dateofissue             : Yup.string().required('Required'),
                expirydate              : Yup.string().required('Required'),
                officeusedate           : Yup.string().required('Required'),
                initialcertdate         : Yup.string().required('Required')
    })

    if (companyListLoading ) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
        // window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="formOuterDiv">
                                                        <div className="form1RowDiv"> 
                                                            <FormikControl control='selectNACECode' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text" label='Name of the Organization'/>                                        
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='legalname' label='Legal Name *' />
                                                            <FormikControl control='input' type="text" name='cdcmember' label='CDC Member *' />

                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='input' type="text" name='nabcbcodeName' label='NACE Code' disabled= {true}/>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' type="text" name='dateofaudit' label='Audit Date' dateFormat="dd-MM-yyyy" disabled= {true}/>
                                                            <FormikControl control='input' type="text" name='typeofaudit' label='Audit Type' disabled= {true}/>

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='refno' label='Reference No' disabled= {true} />
                                                            <FormikControl control='input' type="text" name='standard' label='Standard *' />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='mandaysPlanned' label='Audit Man-days' disabled= {true} />
                                                            <FormikControl control='input' type="text" name='teamleaderName' label='Lead auditors' disabled= {true} />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='technicalExpertName' label='Technical expert' disabled= {true}/>
                                                            <FormikControl  type="text" name='auditorOneName' label='Auditors'  disabled= {true}  />
                                                        </div>
                                                        
                                                        <div className="row mt-4">
                                                        <div className="hrstyle headingcolor">
                                                                <h5>Audit Findings</h5>
                                                        </div>
</div>
                                                     
                                                        <div className="row mt-3" style={{marginLeft:"0.2%"}}>
                                                            <label htmlFor="staticEmail" className="col-sm-6">All activities are found satisfactory  Completed </label>
                                                            <div className="col-sm-3">
                                                                <FormikControl control='radio' name='allactfoundsat' options={auditfindings} />
                                                            </div>

                                                        </div>
                                                        <div className="row" style={{marginLeft:"0.2%"}}>
                                                            <label htmlFor="staticEmail" className="col-sm-6">Certification Criteria have been met</label>
                                                            <div className="col-sm-3">
                                                                <FormikControl control='radio' name='certificationcriteria' options={auditfindings} />
                                                            </div>

                                                        </div>
                                                        <div className="row" style={{marginLeft:"0.2%"}}>
                                                            <label htmlFor="staticEmail" className="col-sm-6">Adequate Justifications for LA’s Recommendations</label>
                                                            <div className="col-sm-3">
                                                                <FormikControl control='radio' name='adejustification' options={auditfindings} />
                                                            </div>

                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" name='docreview' label='Document Review Comments' />
                                                        </div>

                                                        <div className="formRowDiv">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead className="table-primary">
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th scope="col" className="text-center" width="50%">System Review</th>
                                                                        <th scope="col" className="text-center">Review</th>
                                                                        <th scope="col" className="text-center">Comments/Remarks</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr >
                                                                        <td className="text-center" >1</td>
                                                                        <td>Application Review</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview1' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark1' /> </td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td className="text-center" >2</td>
                                                                        <td>Contract Agreement</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview12' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark2' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >3</td>
                                                                        <td>Audit Team Selection</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview3' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark3' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >4</td>
                                                                        <td>Audit mandaysPlanned calculation</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview4' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark4' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >5</td>
                                                                        <td>Stage 1 Audit Report</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview5' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark5' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >6</td>
                                                                        <td>Stage 2/ Recertification Audit Report</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview6' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark6' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >7</td>
                                                                        <td>NC Report &Closure evidence (if any) </td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview7' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark7' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >8</td>
                                                                        <td>Legal Document of Client </td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='sysreview8' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='sysreviewremark8' /> </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        </div>
                                                        </div>
                                                        </div>
                                                        <div className="form2RowDiv mt-3">
                                                            <FormikControl control='date' type="text" name='reviewbydate' dateFormat="dd-MM-yyyy" label='Review Done By / Date *' maxDate={new Date()} />

                                                        </div>

                                                        <div className="formRowDiv mt-3">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead className="table-primary">
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th scope="col" className="text-center" width="50%">Technical Review</th>
                                                                        <th scope="col" className="text-center">Review</th>
                                                                        <th scope="col" className="text-center">Comments/Remarks</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr >
                                                                        <td className="text-center">1</td>
                                                                        <td>Scope Statement against ANZSIC code</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview1' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark1' /> </td>
                                                                    </tr>
                                                                    <tr >
                                                                        <td className="text-center" >2</td>
                                                                        <td>Exclusion and Justification adequate</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview2' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark2' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >3</td>
                                                                        <td>Has auditors covered all the applicable Clauses (Stage 1 & Stage 2 Audit)</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview3' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark3' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >4</td>
                                                                        <td>Evidences are appropriate </td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview4' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark4' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >5</td>
                                                                        <td>NC statement and its clause ref.</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview5' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark5' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >6</td>
                                                                        <td>Verification of Corrective actions and Evidence</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview6' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark6' /> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center" >7</td>
                                                                        <td>Client Acceptance of Stage 2 Audit Report</td>
                                                                        <td><FormikControl control='selecttable' options={yesNo} name='techreview7' style={{textAlign:"center"}}/></td>
                                                                        <td><FormikControl control='inputtable' type="text" name='techreviewremark7' /> </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        </div>
                                                        </div>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' type="text" name='reviewbydate1' className="form-control" dateFormat="dd-MM-yyyy" label='Review Done By / Date *'  maxDate={new Date()}/>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" name='cdcreviewcomments' className="form-control" label='CDC Review Comments' />
                                                        </div>

                                                       
                                                        <div className="row mt-4 ">
                                                        <div className="hrstyle headingcolor">
                                                                <h5>For Recertification</h5>
                                                        </div>
                                                       </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" name='reviewsysduringcert' className="form-control" label='Review of the system during certification tenure and complaints received if any from the customer of the certified client or any other sources' />
                                                        </div>
                                                        <div className="row" style={{marginLeft:"0.01%"}}>
                                                            <label htmlFor="staticEmail" className="col-sm-5">Certificate Decision 
                                                           
                                                            </label>
                                                            <div className="col-sm-4">
                                                                <FormikControl control='radio' name='certificatedec' options={options1}  />
                                                            </div>

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            {/* <FormikControl control='input' type="text" name='signcdcmem' label='Signature Of CDC Member' /> */}
                                                            <FormikControl control='date' type="text" dateFormat="dd-MM-yyyy" name='dateofcdcdecision' className="form-control" label='Date of CDC decision'  maxDate={new Date()}/>

                                                        </div>
                                                        <hr />
                                                        <div className="row mt-4">
                                                        <div className="hrstyle headingcolor" >
                                                                <h5>For Office Use</h5>
                                                        </div>
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='flatno' label='File No *' className="form-control" />
                                                            <FormikControl control='input' type="text" name='certificateno' className="form-control" label='Certificate No *' />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' type="text" dateFormat="dd-MM-yyyy" maxDate={new Date()} name='initialcertdate' label='Initial Certification Date *' className="form-control"  />
                                                            <FormikControl control='date' type="text" dateFormat="dd-MM-yyyy" name='dateofissue' className="form-control" label='Date of Issue *' />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' type="text" dateFormat="dd-MM-yyyy" name='expirydate' label='Expiry date *' className="form-control" />
                                                            <FormikControl control='input' type="text" name='accreditationref' label='Accreditation Reference ' className="form-control" />

                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='input' type="text" name='actionifany' label='Action if any ' className="form-control" />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            {/* <FormikControl control='input' type="text" name='signature' label='Signature' className="form-control" /> */}
                                                            <FormikControl control='date' type="text" name='officeusedate' dateFormat="dd-MM-yyyy" label='Date *' className="form-control"  maxDate={new Date()}/>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                  
                </Form>
                }
            </Formik>
        </div>
    )
}

export default CertificateDecCommittee